export const PHYSICAL_AI_INTELLIGENCE_UPDATED = "2026-08-13";

export const physicalAIModels = [
  {
    id: "gemini-robotics-2",
    model: "Gemini Robotics 2",
    organization: "Google DeepMind",
    country: "United States",
    releaseDate: "2026-07-30",
    category: "VLA / whole-body control",
    architecture: "Closed multimodal robotics model; detailed parameter count not publicly disclosed",
    parameters: "Not disclosed",
    inputs: "Vision, language and robot state",
    outputs: "Robot actions",
    embodiments: "Humanoids and manipulation platforms shown in official material",
    trainingData: "Not disclosed in comparable aggregate form",
    realWorld: "Official real-robot demonstrations including whole-body humanoid control",
    benchmark: "Task-specific official evaluations; protocols vary by robot and task",
    hardware: "Not disclosed as one universal inference target",
    latency: "Not disclosed",
    controlFrequency: "Not disclosed",
    openSource: "Closed",
    code: "Not public",
    weights: "Not public",
    license: "Selected product/research access",
    evidence: "Official model page",
    sourceLabel: "Google DeepMind - Gemini Robotics 2",
    sourceUrl: "https://deepmind.google/blog/gemini-robotics-2-brings-whole-body-intelligence-to-robots/",
    lastVerified: "2026-08-13",
  },
  {
    id: "gemini-robotics-on-device-2",
    model: "Gemini Robotics On-Device 2",
    organization: "Google DeepMind",
    country: "United States",
    releaseDate: "2026-07-30",
    category: "On-device VLA",
    architecture: "On-device vision-language-action model",
    parameters: "Not disclosed",
    inputs: "Vision, language and robot state",
    outputs: "Robot actions",
    embodiments: "Real robots shown in official evaluation material",
    trainingData: "Not disclosed",
    realWorld: "Official real-robot evaluation",
    benchmark: "Model-card evaluations; not directly comparable with cloud or different-hardware systems",
    hardware: "On-device deployment; exact target depends on access configuration",
    latency: "Not disclosed",
    controlFrequency: "Not disclosed",
    openSource: "Closed",
    code: "Not public",
    weights: "Not public",
    license: "Limited access",
    evidence: "Official model card",
    sourceLabel: "Google DeepMind - On-Device 2 model card",
    sourceUrl: "https://deepmind.google/models/model-cards/gemini-robotics-on-device-2/",
    lastVerified: "2026-08-13",
  },
  {
    id: "isaac-gr00t-n1-7",
    model: "Isaac GR00T N1.7",
    organization: "NVIDIA",
    country: "United States",
    releaseDate: "2026-07-07",
    category: "Open reasoning VLA / robot foundation model",
    architecture: "Vision-language reasoning plus action generation; cross-embodiment post-training workflow",
    parameters: "Version-specific; repository publishes model details",
    inputs: "Language, images and robot state",
    outputs: "Robot action trajectories",
    embodiments: "Humanoid, semi-humanoid and bimanual datasets; adapted to target embodiments",
    trainingData: "Mixture of real robot, human video, simulation and generated trajectories",
    realWorld: "Official humanoid and manipulation workflows",
    benchmark: "Version-specific research evaluations",
    hardware: "NVIDIA GPU workflows",
    latency: "Version and hardware dependent",
    controlFrequency: "Version and task dependent",
    openSource: "Open model and code",
    code: "Public GitHub",
    weights: "Public",
    license: "Code: Apache 2.0; model weights: NVIDIA Open Model License",
    evidence: "Official repository",
    sourceLabel: "NVIDIA Isaac GR00T N1.7",
    sourceUrl: "https://github.com/NVIDIA/Isaac-GR00T",
    lastVerified: "2026-08-13",
  },
  {
    id: "openvla-7b",
    model: "OpenVLA 7B",
    organization: "Stanford / UC Berkeley / collaborators",
    country: "United States",
    releaseDate: "2024-06",
    category: "Open-source VLA",
    architecture: "7B vision-language-action model",
    parameters: "7B",
    inputs: "RGB image and language instruction",
    outputs: "Tokenized robot actions",
    embodiments: "Multiple manipulation robots through Open X-Embodiment data and adaptation",
    trainingData: "970,000 robot episodes from Open X-Embodiment",
    realWorld: "Real-robot manipulation evaluations reported by the authors",
    benchmark: "BridgeData and LIBERO-style evaluations in project material",
    hardware: "GPU inference; configuration dependent",
    latency: "Not one standardized value across deployments",
    controlFrequency: "Configuration dependent",
    openSource: "Open",
    code: "Public",
    weights: "Public",
    license: "See repository/model terms",
    evidence: "Official project page",
    sourceLabel: "OpenVLA official project",
    sourceUrl: "https://openvla.github.io/",
    lastVerified: "2026-08-13",
  },
  {
    id: "pi0",
    model: "π0",
    organization: "Physical Intelligence",
    country: "United States",
    releaseDate: "2024-10-31",
    category: "Generalist VLA policy",
    architecture: "Flow-matching VLA built on a pretrained vision-language model",
    parameters: "Not represented here as one deployment-equivalent number",
    inputs: "Images, language and proprioception",
    outputs: "Continuous robot actions",
    embodiments: "Multiple robot platforms in training and evaluation",
    trainingData: "Large-scale multi-task, multi-robot data; aggregate public quantity not normalized here",
    realWorld: "Official real-robot manipulation demonstrations and research evaluations",
    benchmark: "Task-specific research evaluations",
    hardware: "Configuration dependent",
    latency: "Configuration dependent",
    controlFrequency: "Configuration dependent",
    openSource: "Partially open through openpi",
    code: "Public openpi repository",
    weights: "Selected checkpoints available through openpi",
    license: "Repository/model-specific terms",
    evidence: "Official research post",
    sourceLabel: "Physical Intelligence - π0",
    sourceUrl: "https://www.pi.website/blog/pi0",
    lastVerified: "2026-08-13",
  },
  {
    id: "octo",
    model: "Octo",
    organization: "UC Berkeley / collaborators",
    country: "United States",
    releaseDate: "2024",
    category: "Generalist robot policy",
    architecture: "Transformer-based generalist policy trained across robot datasets",
    parameters: "Version dependent",
    inputs: "Images, language and task observations",
    outputs: "Action chunks",
    embodiments: "Multiple robot embodiments with target fine-tuning",
    trainingData: "Cross-embodiment robot datasets",
    realWorld: "Real-robot fine-tuning and evaluation reported by the project",
    benchmark: "Cross-dataset and target-robot evaluations",
    hardware: "Configuration dependent",
    latency: "Not standardized across target robots",
    controlFrequency: "Target robot dependent",
    openSource: "Open",
    code: "Public",
    weights: "Public checkpoints",
    license: "Repository/model-specific terms",
    evidence: "Official project page",
    sourceLabel: "Octo official project",
    sourceUrl: "https://octo-models.github.io/",
    lastVerified: "2026-08-13",
  },
  {
    id: "lingbot-vla-2",
    model: "LingBot-VLA 2.0",
    organization: "Robbyant / Ant Group",
    country: "China",
    releaseDate: "2026-07-08",
    category: "Open-source VLA foundation model",
    architecture: "6B VLA with a canonical cross-embodiment action representation",
    parameters: "6B",
    inputs: "Vision, language and robot state",
    outputs: "Canonical robot actions mapped to target embodiment",
    embodiments: "20 robot configurations",
    trainingData: "~50,000 hours robot trajectories + ~10,000 hours egocentric human video",
    realWorld: "Official real-robot application and evaluation material",
    benchmark: "Simulation and real-world evaluations in project release",
    hardware: "GPU deployment; repository documents deployment paths",
    latency: "Configuration dependent",
    controlFrequency: "Configuration dependent",
    openSource: "Open",
    code: "Public",
    weights: "Public 6B checkpoint",
    license: "Apache-2.0 code",
    evidence: "Official GitHub",
    sourceLabel: "Robbyant - LingBot-VLA 2.0",
    sourceUrl: "https://github.com/Robbyant/lingbot-vla-v2",
    lastVerified: "2026-08-13",
  },
  {
    id: "xr-1",
    model: "XR-1",
    organization: "Beijing Humanoid Robot Innovation Center",
    country: "China",
    releaseDate: "2025-12-18",
    category: "Cross-embodiment VLA",
    architecture: "Unified Vision-Motion Codes with multi-stage VLA training",
    parameters: "Not represented as one comparable public deployment number",
    inputs: "Vision, language and robot motion/state",
    outputs: "Robot actions through unified vision-motion representation",
    embodiments: "Six real robot embodiments in published evaluation",
    trainingData: "Large-scale heterogeneous robot data; linked to RoboMIND ecosystem",
    realWorld: ">14,000 reported real-world rollouts across >120 tasks in the paper",
    benchmark: "Real-world cross-embodiment comparison against multiple VLA baselines",
    hardware: "Not standardized as one inference target",
    latency: "Not disclosed here",
    controlFrequency: "Not disclosed here",
    openSource: "Open project artifacts",
    code: "Public GitHub",
    weights: "Project release",
    license: "Repository-specific terms",
    evidence: "Official project repository / paper",
    sourceLabel: "Open X-Humanoid - XR-1",
    sourceUrl: "https://github.com/Open-X-Humanoid/XR-1",
    lastVerified: "2026-08-13",
  },
  {
    id: "rdt-1b",
    model: "RDT-1B",
    organization: "Tsinghua University / collaborators",
    country: "China",
    releaseDate: "2024-10-10",
    category: "Diffusion robot foundation model",
    architecture: "1.2B Robotics Diffusion Transformer",
    parameters: "1.2B",
    inputs: "Language plus up to three RGB views",
    outputs: "Next 64 robot actions",
    embodiments: "Single-arm, dual-arm and mobile-manipulator-compatible action spaces",
    trainingData: "1M+ episodes from 46 multi-robot datasets; 6K+ ALOHA episodes for bimanual fine-tuning",
    realWorld: "Real-robot bimanual evaluations",
    benchmark: "Author-reported zero-shot object/scene generalization and few-shot skill learning",
    hardware: "GPU inference; target setup dependent",
    latency: "Not standardized here",
    controlFrequency: "Action-chunk execution depends on target controller",
    openSource: "Open",
    code: "Public",
    weights: "Public",
    license: "MIT for released code/weights/data package stated by model card",
    evidence: "Official project page",
    sourceLabel: "RDT-1B official project",
    sourceUrl: "https://rdt-robotics.github.io/rdt-robotics/",
    lastVerified: "2026-08-13",
  },
  {
    id: "turbovla",
    model: "TurboVLA",
    organization: "Huazhong University of Science and Technology / Huawei",
    country: "China",
    releaseDate: "2026-07-29",
    category: "Efficient VLA",
    architecture: "DINOv3 vision encoder + BERT instruction encoder + ACT-style action decoder",
    parameters: "216.1M LIBERO configuration; 0.4B bimanual configuration",
    inputs: "RGB/RGB-D observations and language",
    outputs: "Continuous action chunks",
    embodiments: "LIBERO simulation, RoboTwin bimanual setup and AgileX Piper real arm",
    trainingData: "Benchmark pretraining plus 65 teleoperated demonstrations per real-robot task",
    realWorld: "160 real-robot trials on AgileX Piper across four tabletop tasks",
    benchmark: "97.7% LIBERO average; task-specific real-robot results retained separately",
    hardware: "RTX 4090 for published latency measurement",
    latency: "31.2 ms (216.1M configuration, batch 1, RTX 4090)",
    controlFrequency: "~32 policy predictions/s from reported latency; not the full servo loop",
    openSource: "Open code",
    code: "Public",
    weights: "Published benchmark checkpoints",
    license: "Apache-2.0 code; checkpoint terms include upstream model conditions",
    evidence: "Official project / author paper",
    sourceLabel: "TurboVLA official project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
    lastVerified: "2026-08-13",
  },
];

export const chinaPhysicalAIModels = [
  ...physicalAIModels.filter((item) => item.country === "China"),
  {
    id: "chatvla",
    model: "ChatVLA",
    organization: "Midea AI",
    country: "China",
    releaseDate: "2025",
    category: "VLA",
    architecture: "Unified multimodal understanding and robot-control model with robot-data and vision-language co-training stages",
    parameters: "Not normalized here",
    inputs: "Vision and language with robot observations",
    outputs: "Robot actions",
    embodiments: "Research manipulation platforms",
    trainingData: "Robot data plus vision-language data; quantities depend on experiment",
    realWorld: "Research evaluation reported by authors",
    benchmark: "Paper-specific evaluation",
    hardware: "Not standardized",
    latency: "Not disclosed here",
    controlFrequency: "Not disclosed here",
    openSource: "Open repository and weights",
    code: "Public GitHub",
    weights: "Public link in repository",
    license: "Repository/model-specific terms",
    evidence: "Official repository",
    sourceLabel: "Midea AI - ChatVLA",
    sourceUrl: "https://github.com/midea-ai/ChatVLA_public",
    lastVerified: "2026-08-13",
  },
  {
    id: "lingbot-va",
    model: "LingBot-VA",
    organization: "Robbyant / Ant Group",
    country: "China",
    releaseDate: "2026",
    category: "World-action / video-action model",
    architecture: "Causal world modeling for robot control",
    parameters: "Not disclosed in one comparable public figure",
    inputs: "Visual observations and robot/action context",
    outputs: "World/action predictions used for robot control",
    embodiments: "Simulation and robot-control workflows",
    trainingData: "Project-specific mixed data",
    realWorld: "Official project demos and deployment instructions",
    benchmark: "Project-specific",
    hardware: "GPU; standalone or server-client inference supported",
    latency: "Configuration dependent",
    controlFrequency: "Configuration dependent",
    openSource: "Open repository",
    code: "Public GitHub",
    weights: "See project release",
    license: "Repository-specific terms",
    evidence: "Official repository",
    sourceLabel: "Robbyant - LingBot-VA",
    sourceUrl: "https://github.com/robbyant/lingbot-va",
    lastVerified: "2026-08-13",
  },
];

export const physicalAIBenchmarks = [
  {
    id: "turbovla-libero",
    benchmark: "LIBERO (40 tasks across four suites)",
    task: "General manipulation suites",
    model: "TurboVLA 216.1M",
    robot: "LIBERO simulated robot",
    embodiment: "Single-arm manipulation",
    environment: "Simulation",
    trials: "2,000 total (50 rollouts × 40 tasks)",
    metric: "Average success rate",
    score: "97.7%",
    protocol: "Author evaluation; same paper protocol for listed baselines",
    evaluation: "Simulation",
    adaptation: "Benchmark-trained configuration",
    publicationDate: "2026-07-29",
    evidence: "Research result",
    sourceLabel: "TurboVLA project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
    notes: "Do not compare directly with different LIBERO implementations, checkpoints or rollout rules.",
  },
  {
    id: "turbovla-piper-roller",
    benchmark: "AgileX Piper real-robot evaluation",
    task: "Grab the roller",
    model: "TurboVLA",
    robot: "AgileX Piper",
    embodiment: "Single-arm",
    environment: "Real lab tabletop",
    trials: "40",
    metric: "Success rate",
    score: "92.5%",
    protocol: "65 teleoperated demonstrations for task; model then evaluated over 40 trials",
    evaluation: "Real world",
    adaptation: "Fine-tuned",
    publicationDate: "2026-07-29",
    evidence: "Research result",
    sourceLabel: "TurboVLA project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
    notes: "Task-specific result; not a general reliability score.",
  },
  {
    id: "turbovla-piper-card",
    benchmark: "AgileX Piper real-robot evaluation",
    task: "Move the playing card",
    model: "TurboVLA",
    robot: "AgileX Piper",
    embodiment: "Single-arm",
    environment: "Real lab tabletop",
    trials: "40",
    metric: "Success rate",
    score: "80%",
    protocol: "65 teleoperated demonstrations for task; model then evaluated over 40 trials",
    evaluation: "Real world",
    adaptation: "Fine-tuned",
    publicationDate: "2026-07-29",
    evidence: "Research result",
    sourceLabel: "TurboVLA project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
    notes: "Task-specific result; failure causes are not inferred from the aggregate score.",
  },
  {
    id: "turbovla-piper-stapler",
    benchmark: "AgileX Piper real-robot evaluation",
    task: "Press the stapler",
    model: "TurboVLA",
    robot: "AgileX Piper",
    embodiment: "Single-arm",
    environment: "Real lab tabletop",
    trials: "40",
    metric: "Success rate",
    score: "90%",
    protocol: "65 teleoperated demonstrations for task; model then evaluated over 40 trials",
    evaluation: "Real world",
    adaptation: "Fine-tuned",
    publicationDate: "2026-07-29",
    evidence: "Research result",
    sourceLabel: "TurboVLA project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
    notes: "Task-specific result under one robot and camera setup.",
  },
  {
    id: "turbovla-piper-bowls",
    benchmark: "AgileX Piper real-robot evaluation",
    task: "Stack three bowls",
    model: "TurboVLA",
    robot: "AgileX Piper",
    embodiment: "Single-arm",
    environment: "Real lab tabletop",
    trials: "40",
    metric: "Success rate",
    score: "87.5%",
    protocol: "65 teleoperated demonstrations for task; model then evaluated over 40 trials",
    evaluation: "Real world",
    adaptation: "Fine-tuned",
    publicationDate: "2026-07-29",
    evidence: "Research result",
    sourceLabel: "TurboVLA project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
    notes: "Longer manipulation sequence than the other Piper tasks; still a controlled lab benchmark.",
  },
  {
    id: "motubrain-robotwin-clean",
    benchmark: "RoboTwin 2.0 Clean",
    task: "Multi-task robot control",
    model: "MotuBrain",
    robot: "RoboTwin 2.0 embodiments",
    embodiment: "Cross-embodiment manipulation",
    environment: "Simulation benchmark",
    trials: "See paper protocol",
    metric: "Average success rate",
    score: "95.8%",
    protocol: "Author-reported benchmark; compare only under the same RoboTwin 2.0 setup",
    evaluation: "Simulation",
    adaptation: "Post-trained",
    publicationDate: "2026-04-30",
    evidence: "Research result",
    sourceLabel: "MotuBrain paper",
    sourceUrl: "https://arxiv.org/abs/2604.27792",
    notes: "Paper reports 96.1% under its randomized setting; conditions must stay visible.",
  },
  {
    id: "wla0-robotwin-clean",
    benchmark: "RoboTwin 2.0 Clean",
    task: "Multi-task / long-horizon learning",
    model: "WLA-0",
    robot: "RoboTwin 2.0 embodiments",
    embodiment: "Manipulation",
    environment: "Benchmark environment",
    trials: "See paper protocol",
    metric: "Success rate",
    score: "92.94%",
    protocol: "Author-reported WLA-0 evaluation",
    evaluation: "Research benchmark",
    adaptation: "Model-specific training",
    publicationDate: "2026-06-04",
    evidence: "Research result",
    sourceLabel: "WLA-0 paper",
    sourceUrl: "https://arxiv.org/abs/2606.05979",
    notes: "Do not rank against other RoboTwin results unless versions, tasks and protocol match.",
  },
];

export const physicalAIRealRobotTests = [
  {
    id: "turbovla-piper",
    organization: "HUST / Huawei",
    model: "TurboVLA",
    robot: "AgileX Piper",
    task: "Four tabletop tasks roller, playing card, stapler, bowl stacking",
    environment: "Lab tabletop",
    controlMode: "Autonomous policy execution after teleoperated training data collection",
    autonomyLevel: "Task policy",
    trials: "160 total",
    successes: "37 + 32 + 36 + 35 = 140",
    failures: "20 total inferred exactly from published trial counts and success rates",
    successRate: "87.5% aggregate across the four 40-trial task sets",
    interventions: "Runtime intervention count not reported",
    recovery: "Not reported in aggregate",
    duration: "Not reported",
    demoConditions: "Two RGB-D camera views; 65 teleoperated demonstrations per task",
    limitations: "Controlled tabletop tasks on one arm; no long-duration deployment evidence",
    evidence: "Research result",
    sourceLabel: "TurboVLA project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
    verified: "2026-08-13",
  },
  {
    id: "xr1-real-world",
    organization: "Beijing Humanoid Robot Innovation Center",
    model: "XR-1",
    robot: "Six robot embodiments",
    task: ">120 manipulation tasks",
    environment: "Real-world research evaluations",
    controlMode: "Learned VLA policy",
    autonomyLevel: "Autonomous evaluation under paper protocol",
    trials: ">14,000 rollouts reported",
    successes: "Model/task-specific; no single aggregate count represented here",
    failures: "Model/task-specific; no single aggregate count represented here",
    successRate: "Not reduced to one cross-task figure here",
    interventions: "See paper protocol",
    recovery: "Not represented as a common metric",
    duration: "Not disclosed as one aggregate runtime",
    demoConditions: "Six embodiments and heterogeneous tasks; multi-stage training",
    limitations: "Published research evaluation, not proof of unsupervised production deployment",
    evidence: "Research result",
    sourceLabel: "XR-1 project",
    sourceUrl: "https://xr-1-vla.github.io/",
    verified: "2026-08-13",
  },
  {
    id: "rdt-real-world",
    organization: "Tsinghua University / collaborators",
    model: "RDT-1B",
    robot: "ALOHA dual-arm and other manipulation platforms",
    task: "Bimanual manipulation, language following, unseen objects/scenes and few-shot skills",
    environment: "Real robot research evaluation",
    controlMode: "Diffusion action policy",
    autonomyLevel: "Autonomous policy evaluation under paper protocol",
    trials: "See paper",
    successes: "See task-specific tables",
    failures: "See task-specific tables",
    successRate: "Not collapsed into one universal number",
    interventions: "Not normalized here",
    recovery: "Not reported as one common metric",
    duration: "Not disclosed as long-duration operation",
    demoConditions: "Fine-tuned with 6K+ ALOHA episodes after 1M+ episode multi-robot pretraining",
    limitations: "Research task protocols differ from deployment workloads",
    evidence: "Research result",
    sourceLabel: "RDT-1B project",
    sourceUrl: "https://rdt-robotics.github.io/rdt-robotics/",
    verified: "2026-08-13",
  },
  {
    id: "gemini-robotics-2-apollo",
    organization: "Google DeepMind",
    model: "Gemini Robotics 2",
    robot: "Apptronik Apollo",
    task: "Whole-body locomotion plus manipulation demonstrations",
    environment: "Real robot demonstrations",
    controlMode: "VLA whole-body control",
    autonomyLevel: "Official autonomous task demonstrations; exact supervision varies by experiment",
    trials: "Not disclosed as one common total",
    successes: "Not disclosed as one common total",
    failures: "Not disclosed as one common total",
    successRate: "Task-specific official results",
    interventions: "Not disclosed as one common rate",
    recovery: "Demonstrated in selected scenarios; denominator not public",
    duration: "Not disclosed",
    demoConditions: "Official Google DeepMind evaluation setup",
    limitations: "Closed model and controlled evaluation; public data does not establish fleet reliability",
    evidence: "Official demo",
    sourceLabel: "Gemini Robotics 2",
    sourceUrl: "https://deepmind.google/blog/gemini-robotics-2-brings-whole-body-intelligence-to-robots/",
    verified: "2026-08-13",
  },
  {
    id: "openvla-real-world",
    organization: "Stanford / UC Berkeley / collaborators",
    model: "OpenVLA 7B",
    robot: "Multiple manipulation robots",
    task: "Language-conditioned manipulation",
    environment: "Real robot research evaluations",
    controlMode: "VLA policy",
    autonomyLevel: "Autonomous policy evaluation under project protocol",
    trials: "Protocol-dependent",
    successes: "Protocol-dependent",
    failures: "Protocol-dependent",
    successRate: "See individual project evaluations",
    interventions: "Not normalized across platforms",
    recovery: "Not a common reported metric",
    duration: "Not long-duration deployment evidence",
    demoConditions: "Model pretrained on Open X-Embodiment and adapted/evaluated on target setups",
    limitations: "Different robots require adaptation; benchmark and real-world protocols are not interchangeable",
    evidence: "Research result",
    sourceLabel: "OpenVLA project",
    sourceUrl: "https://openvla.github.io/",
    verified: "2026-08-13",
  },
];

export const physicalAITrainingData = [
  {
    id: "lingbot-vla-2-data",
    dataset: "LingBot-VLA 2.0 pretraining mix",
    organization: "Robbyant / Ant Group",
    country: "China",
    models: "LingBot-VLA 2.0",
    hours: "~60,000 total reported",
    trajectories: "Not converted from hours",
    episodes: "Not disclosed as one aggregate count",
    videoHours: "~10,000 egocentric human video hours",
    robotHours: "~50,000 robot trajectory hours",
    robots: "20 robot configurations",
    embodiments: "20 configurations",
    environments: "Multiple real-world robot collection setups",
    tasks: "General embodied manipulation/control data",
    modalities: "Vision, language, robot state/action; human egocentric video in pretraining mix",
    collection: "Real robot + egocentric human video",
    publicStatus: "Repository links code and model artifacts. It does not present the complete proprietary pretraining corpus as a single downloadable dataset.",
    downloadable: "Model artifacts yes; full training corpus no",
    license: "Apache-2.0 code; dataset availability differs",
    publicationDate: "2026-07-08",
    evidence: "Official repository",
    sourceLabel: "LingBot-VLA 2.0",
    sourceUrl: "https://github.com/Robbyant/lingbot-vla-v2",
    verified: "2026-09-29",
  
"stage": "Pretraining mixture",
"reportedScale": "~50,000 robot hours + ~10,000 egocentric human-video hours",
"comparisonLimit": "Human video and robot-action data are distinct components. The 60,000-hour total does not mean 60,000 robot-control hours."
},
  {
    id: "openvla-openx-data",
    dataset: "OpenVLA pretraining data",
    organization: "OpenVLA collaborators",
    country: "United States",
    models: "OpenVLA 7B",
    hours: "Not converted from episodes",
    trajectories: "970,000 robot episodes reported",
    episodes: "970,000",
    videoHours: "Not used as an equivalent robot-hour metric",
    robotHours: "Not published as one comparable hour total",
    robots: "Multiple Open X-Embodiment robots",
    embodiments: "Multiple",
    environments: "Cross-dataset real-world robot settings",
    tasks: "Manipulation",
    modalities: "RGB, language and robot actions/state depending on source dataset",
    collection: "Real robot datasets",
    publicStatus: "Model/code are released; underlying Open X-Embodiment datasets have separate access and licensing terms.",
    downloadable: "Project artifacts and many underlying datasets",
    license: "Dataset-specific",
    publicationDate: "2024-06",
    evidence: "Official project",
    sourceLabel: "OpenVLA project",
    sourceUrl: "https://openvla.github.io/",
    verified: "2026-09-29",
  
"stage": "Pretraining mixture",
"reportedScale": "970,000 robot episodes from Open X-Embodiment",
"comparisonLimit": "Episode duration varies and no comparable hour total is given. Some underlying datasets also appear in other mixtures."
},
  {
    id: "rdt-pretraining",
    dataset: "RDT-1B multi-robot pretraining collection",
    organization: "Tsinghua University / collaborators",
    country: "China",
    models: "RDT-1B",
    hours: "Not converted from episodes",
    trajectories: "1M+ pretraining episodes; 6K+ ALOHA fine-tuning episodes (separate stages)",
    episodes: "1M+ pretraining; 6K+ ALOHA fine-tuning",
    videoHours: "Not disclosed",
    robotHours: "Not disclosed",
    robots: "46 datasets; multiple robot embodiments",
    embodiments: "Multi-robot",
    environments: "Research manipulation datasets",
    tasks: "Single-arm, bimanual and mobile manipulation",
    modalities: "Language, up to three RGB views, robot actions/state",
    collection: "Real robot datasets",
    publicStatus: "Code, weights and the authors' ALOHA fine-tuning dataset are linked. The model card's MIT statement is not a blanket licence for all 46 source datasets.",
    downloadable: "Yes, subject to linked dataset terms",
    license: "MIT for released package stated by model card; underlying data can differ",
    publicationDate: "2024-10-10",
    evidence: "Official project",
    sourceLabel: "RDT-1B project",
    sourceUrl: "https://rdt-robotics.github.io/rdt-robotics/",
    verified: "2026-09-29",
  
"stage": "Pretraining and fine-tuning",
"reportedScale": "1M+ pretraining episodes from 46 datasets; separately, 6K+ ALOHA fine-tuning episodes",
"comparisonLimit": "The 46-dataset mix and the authors' ALOHA collection describe separate stages. Shared dataset families prevent adding this budget to OpenVLA's.",
"additionalSources": [
  {
    "label": "RDT-1B model card",
    "url": "https://huggingface.co/robotics-diffusion-transformer/rdt-1b"
  },
  {
    "label": "ALOHA fine-tuning dataset",
    "url": "https://huggingface.co/datasets/robotics-diffusion-transformer/rdt-ft-data"
  }
]
},
  {
    id: "robomind-2",
    dataset: "RoboMIND 2.0",
    organization: "Beijing Humanoid Robot Innovation Center / collaborators",
    country: "China",
    models: "XR-1 ecosystem / MIND-2 research",
    hours: "Not converted from trajectories",
    trajectories: "310K+ real-world dual-arm trajectories + 20K simulated trajectories",
    episodes: "310K+ real-world trajectories",
    videoHours: "Not expressed as hours",
    robotHours: "Not expressed as hours",
    robots: "Six robot embodiments",
    embodiments: "6",
    environments: "Real-world bimanual/mobile manipulation + digital twins",
    tasks: "739 complex tasks",
    modalities: "Multimodal robot data; includes 12K tactile-enhanced and 20K mobile-manipulation trajectories",
    collection: "Real robot + simulation",
    publicStatus: "The paper describes the dataset. Complete file availability and dataset licence were not established by this audit.",
    downloadable: "See project/data release",
    license: "Dataset-specific",
    publicationDate: "2025-12-31",
    evidence: "Research paper",
    sourceLabel: "RoboMIND 2.0 paper, v3",
    sourceUrl: "https://arxiv.org/html/2512.24653v3",
    verified: "2026-09-29",
  
"stage": "Dataset release",
"reportedScale": "310K+ real-world trajectories; an additional 20K simulated trajectories",
"comparisonLimit": "The 12K tactile and 20K mobile-manipulation trajectories are subsets of the real-world data, not extra totals. Six embodiments and 739 tasks describe coverage."
},
  {
    id: "turbovla-piper-data",
    dataset: "TurboVLA AgileX Piper task demonstrations",
    organization: "HUST / Huawei",
    country: "China",
    models: "TurboVLA",
    hours: "Not disclosed; not estimated from demonstration count",
    trajectories: "260 teleoperated demonstrations total across four tasks",
    episodes: "65 demonstrations × 4 tasks",
    videoHours: "Not disclosed",
    robotHours: "Not disclosed",
    robots: "1 AgileX Piper",
    embodiments: "Single-arm",
    environments: "Controlled lab tabletop",
    tasks: "4",
    modalities: "Wrist-view RGB-D, third-view RGB-D, language, robot action/state",
    collection: "Teleoperation + real robot",
    publicStatus: "The v3 paper documents the real-robot protocol. This audit did not establish access to the full 260-demonstration corpus.",
    downloadable: "Code/checkpoints public; real-robot demonstration corpus not represented as fully downloadable here",
    license: "Project-specific",
    publicationDate: "2026-07-29",
    evidence: "Research result",
    sourceLabel: "TurboVLA paper, v3 (27 September 2026)",
    sourceUrl: "https://arxiv.org/pdf/2607.27205v3",
    verified: "2026-09-29",
  
"stage": "Real-robot fine-tuning",
"reportedScale": "65 teleoperated demonstrations per task × 4 tasks = 260",
"comparisonLimit": "This is not the whole training budget: the paper pretrains on LIBERO before Piper fine-tuning. Two RGB-D cameras are documented; no footage was used for this count.",
"additionalSources": [
  {
    "label": "TurboVLA project (different results version)",
    "url": "https://h-embodvis.github.io/TurboVLA/"
  }
]
},
  {
    id: "gr00t-n1-data-mix",
    dataset: "Isaac GR00T N1.7 training mixture",
    organization: "NVIDIA",
    country: "United States",
    models: "Isaac GR00T N1.7",
    hours: "Not disclosed as one comparable aggregate",
    trajectories: "Version-dependent",
    episodes: "Version-dependent",
    videoHours: "20,000 human-video hours (N1.7)",
    robotHours: "Real robot demonstrations included; aggregate not normalized here",
    robots: "Multiple humanoid and manipulation embodiments",
    embodiments: "Multiple",
    environments: "Real robot, simulation and generated-data pipelines",
    tasks: "Humanoid/manipulation skills",
    modalities: "Images, language, robot state/action, synthetic trajectories",
    collection: "Human video + simulation + generated trajectories + real robot",
    publicStatus: "N1.7 code and model release are documented. The repository does not establish a single downloadable package for the entire mixed training corpus.",
    downloadable: "Model/code yes; full mixed corpus no",
    license: "Code: Apache 2.0; model weights: NVIDIA Open Model License",
    publicationDate: "N1.7 release; checked 2026-09-29",
    evidence: "Official repository / paper",
    sourceLabel: "NVIDIA Isaac GR00T",
    sourceUrl: "https://github.com/NVIDIA/Isaac-GR00T",
    verified: "2026-09-29",
  
"stage": "Pretraining mixture",
"reportedScale": "20,000 human-video hours reported for N1.7; no combined robot-hour total used here",
"comparisonLimit": "This row now identifies N1.7 explicitly. Its human-video quantity is not a total for all GR00T N1 releases and is not robot demonstration time."
},
];

export const physicalAIWorldModels = [
  {
    id: "cosmos-3",
    model: "Cosmos 3",
    organization: "NVIDIA",
    release: "2026",
    category: "Omnimodal world foundation model",
    architecture: "Learned world model / mixture-of-transformers family described in project material",
    input: "Language, image, video, audio and action context",
    prediction: "Future multimodal/world representations",
    actionConditioning: "Supported in physical-AI workflows; exact model mode varies",
    horizon: "Model/task dependent",
    spatialRepresentation: "Learned multimodal representation",
    embodiment: "Physical AI / robotics workflows",
    realWorldUse: "Used for synthetic data, reasoning and physical-AI development workflows",
    policyTraining: "Can support policy/data pipelines; not itself equivalent to a low-level robot controller",
    syntheticData: "Yes",
    benchmark: "Version-specific",
    code: "Project-dependent",
    weights: "Project-dependent",
    limitations: "World prediction quality does not establish safe closed-loop robot control",
    evidence: "Official project",
    sourceLabel: "NVIDIA Cosmos",
    sourceUrl: "https://www.nvidia.com/en-us/ai/cosmos/",
    verified: "2026-08-13",
  },
  {
    id: "lingbot-va-world-action",
    model: "LingBot-VA",
    organization: "Robbyant / Ant Group",
    release: "2026",
    category: "Causal world / video-action model",
    architecture: "Causal world modeling for robot control",
    input: "Visual observations plus action/robot context",
    prediction: "World/action predictions",
    actionConditioning: "Yes",
    horizon: "Project-dependent",
    spatialRepresentation: "Video/world representation",
    embodiment: "Robot-control workflows",
    realWorldUse: "Official project demonstrations and inference stack",
    policyTraining: "Designed to connect world modeling and action control",
    syntheticData: "Project-dependent",
    benchmark: "Project-specific",
    code: "Public",
    weights: "See project release",
    limitations: "Project results remain protocol-specific and should not be treated as a universal controller benchmark",
    evidence: "Official repository",
    sourceLabel: "LingBot-VA",
    sourceUrl: "https://github.com/robbyant/lingbot-va",
    verified: "2026-08-13",
  },
  {
    id: "motubrain",
    model: "MotuBrain",
    organization: "MotuBrain Team / collaborators",
    release: "2026-04-30",
    category: "World Action Model",
    architecture: "UniDiffuser-style joint video/action model with three-stream mixture-of-transformers",
    input: "Video, language and robot/action context",
    prediction: "Video and action jointly; supports action-only inference",
    actionConditioning: "Yes",
    horizon: "Long-horizon control evaluated by authors",
    spatialRepresentation: "Multiview learned world representation",
    embodiment: "Heterogeneous robot data; cross-embodiment adaptation",
    realWorldUse: "Real-world control experiments reported",
    policyTraining: "Yes",
    syntheticData: "Supports world-model functions; data use depends on pipeline",
    benchmark: "RoboTwin 2.0 and WorldArena author evaluations",
    code: "See paper/project availability",
    weights: "See project availability",
    limitations: "Author-reported results; hardware/configuration and benchmark protocol must remain attached to claims",
    evidence: "Research paper",
    sourceLabel: "MotuBrain paper",
    sourceUrl: "https://arxiv.org/abs/2604.27792",
    verified: "2026-08-13",
  },
  {
    id: "wla-0",
    model: "WLA-0",
    organization: "Research collaboration",
    release: "2026-06-04",
    category: "World-Language-Action model",
    architecture: "Autoregressive Transformer with world expert and action expert",
    input: "Text instructions, images and robot state",
    prediction: "Textual subtasks, subgoal/world representations and robot actions",
    actionConditioning: "World prediction influences action generation; world prediction can be disabled during inference",
    horizon: "Designed for multi-task and long-horizon learning",
    spatialRepresentation: "Learned visual/world state",
    embodiment: "Cross-embodiment robot video learning claim in research prototype",
    realWorldUse: "Simulated and real-world evaluations reported",
    policyTraining: "Yes",
    syntheticData: "World-prediction objective can support learning; not treated as synthetic-data volume here",
    benchmark: "RoboTwin 2.0 Clean and RMBench author results",
    code: "Not represented here",
    weights: "Not represented here",
    limitations: "Research prototype; cross-paper benchmark comparisons require matching protocols",
    evidence: "Research paper",
    sourceLabel: "WLA-0 paper",
    sourceUrl: "https://arxiv.org/abs/2606.05979",
    verified: "2026-08-13",
  },
];

export const physicalAICrossEmbodiment = [
  {
    id: "gr00t-cross",
    model: "Isaac GR00T N1.7",
    organization: "NVIDIA",
    supportType: "Native multi-embodiment pretraining + target post-training",
    sourceEmbodiment: "Mixed humanoid / bimanual / semi-humanoid data",
    targetEmbodiment: "Target robot configured through post-training",
    platforms: "Multiple robot embodiments",
    actionRepresentation: "Shared model representation with embodiment-specific data/configuration",
    adaptation: "Yes - post-training for target embodiment/task is part of the workflow",
    fineTuning: "Typically yes",
    zeroShotClaim: "True zero-shot transfer to an unseen embodiment is not assumed",
    realWorld: "Official real-robot workflows",
    benchmark: "Version-specific",
    trials: "Protocol-specific",
    status: "Verified model capability; zero-shot embodiment claim not generalized",
    sourceLabel: "NVIDIA GR00T",
    sourceUrl: "https://github.com/NVIDIA/Isaac-GR00T",
  },
  {
    id: "lingbot-cross",
    model: "LingBot-VLA 2.0",
    organization: "Robbyant / Ant Group",
    supportType: "Native multi-embodiment support",
    sourceEmbodiment: "20 robot configurations",
    targetEmbodiment: "Supported configurations / adapted robots",
    platforms: "20 configurations spanning different robot morphologies",
    actionRepresentation: "55-dimensional canonical action representation reported by project",
    adaptation: "Configuration mapping and task adaptation may still be required",
    fineTuning: "Task/robot dependent",
    zeroShotClaim: "Not treated as proven true zero-shot embodiment transfer",
    realWorld: "Official real-robot evidence",
    benchmark: "Project evaluations",
    trials: "Protocol-specific",
    status: "Verified multi-configuration training; zero-shot scope kept separate",
    sourceLabel: "LingBot-VLA 2.0",
    sourceUrl: "https://github.com/Robbyant/lingbot-vla-v2",
  },
  {
    id: "xr1-cross",
    model: "XR-1",
    organization: "Beijing Humanoid Robot Innovation Center",
    supportType: "Native cross-embodiment learning",
    sourceEmbodiment: "Heterogeneous training robots",
    targetEmbodiment: "Six real robot embodiments in evaluation",
    platforms: "Six evaluated embodiments",
    actionRepresentation: "Unified Vision-Motion Codes",
    adaptation: "Three-stage training includes task-specific post-training",
    fineTuning: "Yes in the published training pipeline",
    zeroShotClaim: "Generalization is reported, but this database does not relabel it as zero-shot unseen-body transfer without matching protocol",
    realWorld: ">14,000 real-world rollouts across >120 tasks reported",
    benchmark: "Cross-embodiment real-world comparison",
    trials: ">14,000 rollouts",
    status: "Research result",
    sourceLabel: "XR-1 project",
    sourceUrl: "https://xr-1-vla.github.io/",
  },
  {
    id: "rdt-cross",
    model: "RDT-1B",
    organization: "Tsinghua University / collaborators",
    supportType: "Shared action-space model adapted across robot forms",
    sourceEmbodiment: "46 multi-robot datasets",
    targetEmbodiment: "Single-arm, bimanual and mobile manipulators",
    platforms: "Multiple modern manipulators",
    actionRepresentation: "Physically Interpretable Unified Action Space",
    adaptation: "Fine-tuning / few-shot adaptation used for target skills",
    fineTuning: "Yes for many target settings",
    zeroShotClaim: "Zero-shot object/scene generalization is reported; unseen-embodiment zero-shot is not inferred",
    realWorld: "Real-robot bimanual evaluations",
    benchmark: "Paper-specific",
    trials: "See paper",
    status: "Research result",
    sourceLabel: "RDT-1B project",
    sourceUrl: "https://rdt-robotics.github.io/rdt-robotics/",
  },
  {
    id: "octo-cross",
    model: "Octo",
    organization: "UC Berkeley / collaborators",
    supportType: "Multi-embodiment pretrained policy with target fine-tuning",
    sourceEmbodiment: "Cross-embodiment robot datasets",
    targetEmbodiment: "Multiple target robots",
    platforms: "Multiple manipulation robots",
    actionRepresentation: "Shared policy representation with target adaptation",
    adaptation: "Yes",
    fineTuning: "Yes",
    zeroShotClaim: "Not represented as true zero-shot embodiment transfer",
    realWorld: "Real-robot adaptation/evaluation",
    benchmark: "Project-specific",
    trials: "Protocol-specific",
    status: "Verified open project",
    sourceLabel: "Octo project",
    sourceUrl: "https://octo-models.github.io/",
  },
  {
    id: "gemini-cross",
    model: "Gemini Robotics 2",
    organization: "Google DeepMind",
    supportType: "Cross-embodiment transfer demonstrated by developer",
    sourceEmbodiment: "Multiple robot forms",
    targetEmbodiment: "Multiple robot forms shown in official research",
    platforms: "Humanoid and manipulation platforms",
    actionRepresentation: "Closed internal representation",
    adaptation: "Exact adaptation budget is not uniformly disclosed",
    fineTuning: "Not publicly normalized across demonstrations",
    zeroShotClaim: "Do not assume zero-shot unseen-body transfer",
    realWorld: "Official real-robot demonstrations",
    benchmark: "Task-specific official evaluations",
    trials: "Protocol-specific",
    status: "Official claim / demo",
    sourceLabel: "Gemini Robotics 2",
    sourceUrl: "https://deepmind.google/models/gemini-robotics/",
  },
];

export const physicalAILatency = [
  {
    id: "turbovla-216m-latency",
    model: "TurboVLA",
    version: "216.1M LIBERO configuration",
    organization: "HUST / Huawei",
    hardware: "NVIDIA RTX 4090",
    accelerator: "GPU",
    precision: "Paper configuration; precision should be checked in experiment details",
    modelSize: "216.1M parameters",
    inputResolution: "Project-specific",
    batchSize: "1",
    observationFrequency: "Not equivalent to camera/servo frequency",
    latency: "31.2 ms per policy inference",
    actionFrequency: "~32 policy predictions/s",
    controlFrequency: "Full robot servo loop not claimed to run at 32 Hz",
    location: "On local GPU workstation",
    robot: "Benchmark + AgileX Piper transfer",
    conditions: "Observation-to-action-chunk policy latency on one RTX 4090; excludes full sensing/network/servo pipeline",
    evidence: "Research result",
    sourceLabel: "TurboVLA project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
  },
  {
    id: "turbovla-04b-latency",
    model: "TurboVLA",
    version: "0.4B RoboTwin bimanual configuration",
    organization: "HUST / Huawei",
    hardware: "NVIDIA RTX 4090",
    accelerator: "GPU",
    precision: "Paper configuration",
    modelSize: "0.4B parameters",
    inputResolution: "Three camera views; project-specific resolution",
    batchSize: "1 / paper inference setup",
    observationFrequency: "Not stated as the complete robot-loop frequency",
    latency: "43.4 ms",
    actionFrequency: "~23 policy predictions/s from latency",
    controlFrequency: "Action chunk = 50 steps; low-level controller frequency is separate",
    location: "Local GPU",
    robot: "RoboTwin 2.0 bimanual setup",
    conditions: "Different model size and observation setup from the 216.1M LIBERO configuration",
    evidence: "Research result",
    sourceLabel: "TurboVLA project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
  },
  {
    id: "gr00t-n1-paper-latency",
    model: "Isaac GR00T N1",
    version: "Public N1 paper model",
    organization: "NVIDIA",
    hardware: "NVIDIA L40",
    accelerator: "GPU",
    precision: "bf16",
    modelSize: "2.2B total; 1.34B VLM reported in paper",
    inputResolution: "Paper-specific",
    batchSize: "Paper-specific",
    observationFrequency: "Not represented as full robot-loop frequency",
    latency: "63.9 ms to sample a chunk of 16 actions",
    actionFrequency: "Chunk inference metric; not 16 independent control loops",
    controlFrequency: "Low-level motor control remains separate",
    location: "GPU inference",
    robot: "Generalist humanoid research model",
    conditions: "Published N1 paper, L40 GPU, bf16, 16-action chunk; do not apply directly to N1.7 or other GPUs",
    evidence: "Research paper",
    sourceLabel: "GR00T N1 paper",
    sourceUrl: "https://arxiv.org/abs/2503.14734",
  },
  {
    id: "wla0-latency",
    model: "WLA-0",
    version: "2B active-parameter prototype",
    organization: "Research collaboration",
    hardware: "NVIDIA RTX 5090",
    accelerator: "GPU",
    precision: "Paper configuration",
    modelSize: "2B active parameters",
    inputResolution: "Paper-specific",
    batchSize: "Paper-specific",
    observationFrequency: "Not disclosed as a full system frequency",
    latency: "40 ms per inference",
    actionFrequency: "~25 model inferences/s from reported latency",
    controlFrequency: "Robot low-level control remains separate",
    location: "Local GPU",
    robot: "Research benchmark platforms",
    conditions: "Author-reported on RTX 5090; world prediction can be disabled during inference according to paper",
    evidence: "Research result",
    sourceLabel: "WLA-0 paper",
    sourceUrl: "https://arxiv.org/abs/2606.05979",
  },
];

export const physicalAIDeployments = [
  {
    id: "figure02-bmw",
    model: "Not publicly disclosed in the deployment source",
    robot: "Figure 02",
    robotCompany: "Figure AI",
    aiCompany: "Figure AI",
    customer: "BMW Manufacturing",
    site: "Spartanburg, South Carolina, United States",
    city: "Spartanburg",
    country: "United States",
    industry: "Automotive manufacturing",
    useCase: "Production material handling",
    task: "Sheet-metal loading in BMW X3 production",
    start: "2025",
    robots: "Not disclosed",
    stage: "Completed production deployment reported by Figure",
    operatingHours: ">1,250 runtime hours reported",
    supervision: "Not disclosed as one intervention rate",
    autonomy: "Deployment source does not publish a complete autonomy/intervention protocol",
    interventions: "Not disclosed",
    status: "Completed reported deployment",
    evidence: "Official manufacturer deployment report",
    sourceLabel: "Figure - production at BMW",
    sourceUrl: "https://www.figure.ai/news/production-at-bmw",
    verified: "2026-07-31",
  },
  {
    id: "figure03-bmw",
    model: "Helix 02, named by Figure in the BMW demonstration",
    robot: "Figure 03",
    robotCompany: "Figure AI",
    aiCompany: "Figure AI",
    customer: "BMW Manufacturing",
    site: "Hall 52, Spartanburg, South Carolina, United States",
    city: "Spartanburg",
    country: "United States",
    industry: "Automotive manufacturing",
    useCase: "Sequencing",
    task: "Sequencing use case",
    start: "2026-06-30",
    robots: "Not disclosed",
    stage: "Deployment update",
    operatingHours: "Not disclosed",
    supervision: "Not disclosed",
    autonomy: "Not disclosed as a full operational protocol",
    interventions: "Not disclosed",
    status: "Deployment update",
    evidence: "Official manufacturer deployment update",
    sourceLabel: "Figure - F.03 at BMW",
    sourceUrl: "https://www.figure.ai/news/f-03-at-bmw",
    verified: "2026-07-31",
  },
  {
    id: "digit-gxo",
    model: "Not publicly disclosed as a named foundation model",
    robot: "Agility Digit",
    robotCompany: "Agility Robotics",
    aiCompany: "Agility Robotics",
    customer: "GXO Logistics",
    site: "Flowery Branch, Georgia, United States",
    city: "Flowery Branch",
    country: "United States",
    industry: "Logistics",
    useCase: "Tote handling",
    task: "Moving totes between an AMR and conveyor",
    start: "2024-06-05",
    robots: "Not disclosed in cited update",
    stage: "Commercial deployment",
    operatingHours: "Not disclosed",
    supervision: "Operational human supervision details not normalized here",
    autonomy: "Task automation; exact intervention rate not disclosed in cited source",
    interventions: "Not disclosed",
    status: "Operational deployment",
    evidence: "Official deployment announcement",
    sourceLabel: "Agility Robotics - Digit at GXO",
    sourceUrl: "https://www.agilityrobotics.com/content/digit-deployed-at-gxo-in-historic-humanoid-raas-agreement",
    verified: "2026-07-31",
  },
  {
    id: "apollo-mercedes",
    model: "Not publicly disclosed in the deployment announcement",
    robot: "Apptronik Apollo",
    robotCompany: "Apptronik",
    aiCompany: "Apptronik",
    customer: "Mercedes-Benz",
    site: "Mercedes-Benz manufacturing operations",
    city: "Not disclosed",
    country: "Not disclosed in retained record",
    industry: "Automotive manufacturing",
    useCase: "Parts delivery, kitting and inspection",
    task: "Manufacturing pilot",
    start: "2024-03-15",
    robots: "Not disclosed",
    stage: "Pilot announced",
    operatingHours: "Not disclosed",
    supervision: "Not disclosed",
    autonomy: "Pilot announcement does not establish unrestricted autonomy",
    interventions: "Not disclosed",
    status: "Pilot",
    evidence: "Official company/customer agreement",
    sourceLabel: "Apptronik - Mercedes-Benz agreement",
    sourceUrl: "https://apptronik.com/company/press-releases-collection/apptronik-and-mercedes-benz-enter-commercial-agreement",
    verified: "2026-07-31",
  },
  {
    id: "agibot-longcheer-june-2026",
    model: "Not named in the June 2026 manufacturer report",
    robot: "AGIBOT humanoid fleet (models not specified)",
    robotCompany: "AgiBot",
    aiCompany: "AgiBot",
    customer: "Longcheer Technology",
    site: "Tablet production line, Nanchang, China",
    city: "Nanchang",
    country: "China",
    industry: "Electronics manufacturing",
    useCase: "Multiple tablet-production workflows",
    task: "Production-line quality inspection and handling",
    start: "Six-day operation reported on 2026-06-29; exact start date not stated",
    robots: "Multiple robots; exact count not disclosed",
    stage: "Manufacturer-reported factory operation",
    operatingHours: "More than 64 hours across the reported operation; per-robot hours not disclosed",
    supervision: "Not disclosed",
    autonomy: "The report does not quantify teleoperation or interventions",
    interventions: "Not disclosed",
    status: "Dated factory-operation report",
    evidence: "Manufacturer report; no independent performance verification",
    sourceLabel: "AGIBOT June 2026 Longcheer factory report",
    sourceUrl: "https://www.agibot.com/article/231/detail/83.html",
    verified: "2026-10-11",
  },
];

export const physicalAIFailures = [
  {
    id: "turbovla-roller-failures",
    date: "2026-07-29",
    model: "TurboVLA",
    robot: "AgileX Piper",
    company: "HUST / Huawei",
    task: "Grab the roller",
    environment: "Controlled lab tabletop",
    failureType: "Task failure; specific cause not disclosed in aggregate result",
    description: "3 of 40 evaluation trials were unsuccessful, derived exactly from the published 92.5% success rate and 40-trial denominator.",
    consequence: "Task not completed under evaluation protocol",
    recovered: "Not reported",
    intervention: "Not reported",
    observedFailure: "3 unsuccessful trials",
    companyExplanation: "No single cause assigned to the aggregate failures",
    confirmedCause: "Unknown",
    status: "Research evaluation",
    evidence: "Research result",
    sourceLabel: "TurboVLA project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
  },
  {
    id: "turbovla-card-failures",
    date: "2026-07-29",
    model: "TurboVLA",
    robot: "AgileX Piper",
    company: "HUST / Huawei",
    task: "Move the playing card",
    environment: "Controlled lab tabletop",
    failureType: "Task failure; specific cause not disclosed in aggregate result",
    description: "8 of 40 evaluation trials were unsuccessful, derived exactly from the published 80% success rate and 40-trial denominator.",
    consequence: "Task not completed under evaluation protocol",
    recovered: "Not reported",
    intervention: "Not reported",
    observedFailure: "8 unsuccessful trials",
    companyExplanation: "No single cause assigned to the aggregate failures",
    confirmedCause: "Unknown",
    status: "Research evaluation",
    evidence: "Research result",
    sourceLabel: "TurboVLA project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
  },
  {
    id: "turbovla-stapler-failures",
    date: "2026-07-29",
    model: "TurboVLA",
    robot: "AgileX Piper",
    company: "HUST / Huawei",
    task: "Press the stapler",
    environment: "Controlled lab tabletop",
    failureType: "Task failure; specific cause not disclosed in aggregate result",
    description: "4 of 40 evaluation trials were unsuccessful, derived exactly from the published 90% success rate and 40-trial denominator.",
    consequence: "Task not completed under evaluation protocol",
    recovered: "Not reported",
    intervention: "Not reported",
    observedFailure: "4 unsuccessful trials",
    companyExplanation: "No single cause assigned to the aggregate failures",
    confirmedCause: "Unknown",
    status: "Research evaluation",
    evidence: "Research result",
    sourceLabel: "TurboVLA project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
  },
  {
    id: "turbovla-bowl-failures",
    date: "2026-07-29",
    model: "TurboVLA",
    robot: "AgileX Piper",
    company: "HUST / Huawei",
    task: "Stack three bowls",
    environment: "Controlled lab tabletop",
    failureType: "Task failure; specific cause not disclosed in aggregate result",
    description: "5 of 40 evaluation trials were unsuccessful, derived exactly from the published 87.5% success rate and 40-trial denominator.",
    consequence: "Task not completed under evaluation protocol",
    recovered: "Not reported",
    intervention: "Not reported",
    observedFailure: "5 unsuccessful trials",
    companyExplanation: "No single cause assigned to the aggregate failures",
    confirmedCause: "Unknown",
    status: "Research evaluation",
    evidence: "Research result",
    sourceLabel: "TurboVLA project",
    sourceUrl: "https://h-embodvis.github.io/TurboVLA/",
  },
  {
    id: "agibot-world-grasp",
    date: "2026",
    model: "Not disclosed as one model in the retained taxonomy",
    robot: "AgiBot World dataset",
    company: "AgiBot",
    task: "Manipulation trajectories",
    environment: "Public dataset taxonomy",
    failureType: "Grasp failure",
    description: "AgiBot publicly names grasp failure as an error-trajectory category; comparable frequency is not published in the retained source.",
    consequence: "Error trajectory retained in dataset",
    recovered: "Not disclosed",
    intervention: "Dataset/error-trajectory record",
    observedFailure: "Named category; frequency unknown",
    companyExplanation: "Official dataset taxonomy",
    confirmedCause: "Not established",
    status: "Official taxonomy",
    evidence: "Official announcement",
    sourceLabel: "AgiBot World 2026 Theme 2",
    sourceUrl: "https://www.agibot.com/article/231/detail/72.html",
  },
  {
    id: "agibot-world-collision",
    date: "2026",
    model: "Not disclosed as one model in the retained taxonomy",
    robot: "AgiBot World dataset",
    company: "AgiBot",
    task: "Manipulation trajectories",
    environment: "Public dataset taxonomy",
    failureType: "Collision",
    description: "Collision is a named public error-trajectory category. The cited source does not publish a comparable frequency.",
    consequence: "Error trajectory retained in dataset",
    recovered: "Not disclosed",
    intervention: "Dataset/error-trajectory record",
    observedFailure: "Named category; frequency unknown",
    companyExplanation: "Official dataset taxonomy",
    confirmedCause: "Not established",
    status: "Official taxonomy",
    evidence: "Official announcement",
    sourceLabel: "AgiBot World 2026 Theme 2",
    sourceUrl: "https://www.agibot.com/article/231/detail/72.html",
  },
  {
    id: "agibot-world-object-drop",
    date: "2026",
    model: "Not disclosed as one model in the retained taxonomy",
    robot: "AgiBot World dataset",
    company: "AgiBot",
    task: "Manipulation trajectories",
    environment: "Public dataset taxonomy",
    failureType: "Object drop",
    description: "Object drop is a named public error-trajectory category. The cited source does not publish a comparable frequency.",
    consequence: "Error trajectory retained in dataset",
    recovered: "Not disclosed",
    intervention: "Dataset/error-trajectory record",
    observedFailure: "Named category; frequency unknown",
    companyExplanation: "Official dataset taxonomy",
    confirmedCause: "Not established",
    status: "Official taxonomy",
    evidence: "Official announcement",
    sourceLabel: "AgiBot World 2026 Theme 2",
    sourceUrl: "https://www.agibot.com/article/231/detail/72.html",
  },
];

const modelColumns = [
  ["model", "Model"], ["organization", "Organization"], ["country", "Country"], ["releaseDate", "Release"],
  ["category", "Category"], ["parameters", "Parameters"], ["embodiments", "Embodiments"], ["realWorld", "Real-robot evidence"],
  ["openSource", "Open status"], ["latency", "Inference latency"], ["evidence", "Evidence"]
];

export const physicalAIIntelligencePages = [
  {
    id: "model-tracker",
    path: "/robotics-news/physical-ai-model-map",
    preferredPath: "/physical-ai/model-tracker",
    existing: true,
    title: "Physical AI Model Tracker",
    seoTitle: "Complete Physical AI Model Map Models and Policies 2026",
    description: "Track VLA models, robot foundation models, world-action models and Physical AI policies with technical fields, source links and real-robot evidence.",
    eyebrow: "PHYSICAL AI MODEL INTELLIGENCE",
    methodology: "A model enters this database only when a primary project, paper or official release identifies it. Missing parameter counts, latency, training volume or autonomy details remain Not disclosed rather than being estimated.",
    records: physicalAIModels,
    columns: modelColumns,
    filters: [["category", "Category"], ["organization", "Organization"], ["country", "Country"], ["openSource", "Open status"]],
    updated: "2026-08-13",
  },
  {
    id: "china-model-tracker",
    path: "/physical-ai/china-model-tracker",
    preferredPath: "/physical-ai/china-model-tracker",
    existing: false,
    title: "China Physical AI Model Tracker",
    seoTitle: "China Physical AI Model Tracker VLA and Embodied Models",
    description: "Track Chinese VLA, robot foundation, cross-embodiment and world-action models with Chinese primary sources, technical evidence and open-source status.",
    eyebrow: "CHINA PHYSICAL AI DATABASE",
    methodology: "Organization origin is recorded separately from model architecture. Chinese-language primary sources and official repositories are preferred. A project is not labeled open source unless code or weights are actually released.",
    records: chinaPhysicalAIModels,
    columns: modelColumns,
    filters: [["category", "Category"], ["organization", "Organization"], ["openSource", "Open status"]],
    updated: "2026-08-13",
  },
  {
    id: "benchmarks",
    path: "/data/physical-ai-benchmarks",
    preferredPath: "/data/physical-ai-benchmarks",
    existing: false,
    title: "Physical AI Benchmark Database",
    seoTitle: "Physical AI Benchmark Database Robot Model Results",
    description: "Compare published Physical AI benchmark results while keeping robot, environment, trial count, protocol and adaptation conditions attached to every score.",
    eyebrow: "BENCHMARK CONDITIONS STAY ATTACHED",
    methodology: "Scores are never treated as directly comparable when robots, environments, trial counts, reset rules, benchmark versions or adaptation protocols differ. The table preserves those conditions beside each number.",
    records: physicalAIBenchmarks,
    columns: [["benchmark", "Benchmark"], ["task", "Task"], ["model", "Model"], ["robot", "Robot"], ["environment", "Environment"], ["trials", "Trials"], ["metric", "Metric"], ["score", "Score"], ["adaptation", "Adaptation"], ["protocol", "Protocol"]],
    filters: [["model", "Model"], ["environment", "Environment"], ["adaptation", "Adaptation"]],
    updated: "2026-08-13",
  },
  {
    id: "real-robot-tests",
    path: "/data/physical-ai-real-robot-tests",
    preferredPath: "/data/physical-ai-real-robot-tests",
    existing: false,
    title: "Real-Robot Evidence Database",
    seoTitle: "Physical AI Real-Robot Tests and Autonomy Evidence",
    description: "See what Physical AI models actually demonstrated on real robots, including task, control mode, trials, failures, interventions and evidence limits.",
    eyebrow: "WHAT ACTUALLY RAN ON A REAL ROBOT",
    methodology: "Scripted demos, teleoperation, shared autonomy, autonomous policy tests and deployments are kept separate. Training teleoperation is not mislabeled as runtime teleoperation, and no system is called fully autonomous without explicit evidence.",
    records: physicalAIRealRobotTests,
    columns: [["model", "Model"], ["robot", "Robot"], ["task", "Task"], ["environment", "Environment"], ["controlMode", "Control mode"], ["autonomyLevel", "Autonomy level"], ["trials", "Trials"], ["successRate", "Success"], ["failures", "Failures"], ["interventions", "Human interventions"], ["limitations", "Limitations"]],
    filters: [["model", "Model"], ["robot", "Robot"], ["autonomyLevel", "Autonomy"]],
    updated: "2026-08-13",
  },
  {
    id: "training-data",
    path: "/data/physical-ai-training-data",
    preferredPath: "/data/physical-ai-training-data",
    existing: false,
    title: "Physical AI Training Data: What the Counts Measure",
    seoTitle: "Physical AI Training Data: Hours, Episodes and Training Stages",
    description: "Compare six reported robot-learning data budgets by training stage, unit, included subsets and access limits. Counts are reported by the authors, not independently recounted.",
    eyebrow: "HOURS ≠ TRAJECTORIES ≠ SIMULATION",
    methodology: "These figures answer different questions. LingBot and OpenVLA describe pretraining; TurboVLA's 260 demonstrations describe real-robot fine-tuning after LIBERO pretraining. RoboMIND counts a dataset, not every sample consumed by a model. RDT and OpenVLA draw on overlapping dataset families, so their totals must not be added. Hours are not converted to episodes. A released model or code repository does not establish that its complete training corpus can be downloaded.",
    records: physicalAITrainingData,
    columns: [
  [
    "dataset",
    "Dataset / version"
  ],
  [
    "stage",
    "Training stage"
  ],
  [
    "reportedScale",
    "Author-reported scale"
  ],
  [
    "modalities",
    "Inputs / measurements"
  ],
  [
    "comparisonLimit",
    "Why this is not directly comparable"
  ],
  [
    "publicStatus",
    "Available artifacts / access"
  ],
  [
    "verified",
    "Source checked"
  ]
],
    filters: [
  [
    "stage",
    "Training stage"
  ]
],
    updated: "2026-09-29",
  
"verificationLabel": "Sources checked September 29, 2026"
},
  {
    id: "world-models",
    path: "/robotics-news/world-models-for-robotics",
    preferredPath: "/physical-ai/world-model-database",
    existing: true,
    title: "Physical AI World Model Database",
    seoTitle: "World Models for Robotics Prediction, Planning and Control",
    description: "Classify world models, world-action models and predictive Physical AI systems by architecture, action conditioning, real-world use and policy-training role.",
    eyebrow: "WORLD MODELS FOR ROBOTICS",
    methodology: "Video generation, predictive world modeling, engineered simulation and robot policy control are not treated as synonyms. Each row states what the model predicts and whether action conditioning or real-robot control is actually documented.",
    records: physicalAIWorldModels,
    columns: [["model", "Model"], ["organization", "Organization"], ["release", "Release"], ["category", "Category"], ["architecture", "Architecture"], ["prediction", "Prediction output"], ["actionConditioning", "Action conditioning"], ["embodiment", "Embodiment"], ["realWorldUse", "Real-world use"], ["policyTraining", "Policy-training use"], ["limitations", "Limitations"]],
    filters: [["category", "Category"], ["organization", "Organization"], ["actionConditioning", "Action conditioning"]],
    updated: "2026-08-13",
  },
  {
    id: "cross-embodiment",
    path: "/robotics-news/cross-embodiment-learning",
    preferredPath: "/physical-ai/cross-embodiment-models",
    existing: true,
    title: "Cross-Embodiment Model Tracker",
    seoTitle: "Cross-Embodiment Learning for Modern Robot Control Policies",
    description: "Track which Physical AI models genuinely support multiple robot bodies, what adaptation they require and whether zero-shot transfer is actually demonstrated.",
    eyebrow: "MULTI-BODY DOES NOT ALWAYS MEAN ZERO-SHOT",
    methodology: "Native multi-embodiment support, separate adaptation to multiple robots and true zero-shot unseen-embodiment transfer are labeled separately. Marketing claims are not upgraded into stronger evidence categories.",
    records: physicalAICrossEmbodiment,
    columns: [["model", "Model"], ["organization", "Organization"], ["supportType", "Support type"], ["sourceEmbodiment", "Source embodiment"], ["targetEmbodiment", "Target embodiment"], ["platforms", "Robot platforms"], ["actionRepresentation", "Action representation"], ["adaptation", "Adaptation required"], ["fineTuning", "Fine-tuning"], ["zeroShotClaim", "Zero-shot status"], ["realWorld", "Real-world evidence"], ["status", "Verification"]],
    filters: [["organization", "Organization"], ["supportType", "Support type"], ["fineTuning", "Fine-tuning"]],
    updated: "2026-08-13",
  },
  {
    id: "inference-latency",
    path: "/data/physical-ai-inference-latency",
    preferredPath: "/data/physical-ai-inference-latency",
    existing: false,
    title: "Physical AI Inference Latency Records",
    seoTitle: "Physical AI Inference Latency Models and Hardware",
    description: "Compare published robot-model inference latency with GPU, precision, model size, batch size and test conditions kept visible beside every result.",
    eyebrow: "LATENCY WITHOUT HARDWARE IS MEANINGLESS",
    methodology: "Latency rows are not ranked as hardware-independent model scores. GPU/NPU, precision, model version, batch size, action chunk and measurement boundary stay visible so 40 ms on one accelerator is not treated as equivalent to 40 ms on another.",
    records: physicalAILatency,
    columns: [["model", "Model"], ["version", "Version"], ["hardware", "Hardware"], ["precision", "Precision"], ["modelSize", "Model size"], ["batchSize", "Batch"], ["latency", "Inference latency"], ["actionFrequency", "Action frequency"], ["controlFrequency", "Control frequency note"], ["robot", "Robot / benchmark"], ["conditions", "Test conditions"]],
    filters: [["model", "Model"], ["hardware", "Hardware"], ["accelerator", "Accelerator"]],
    updated: "2026-08-13",
  },
  {
    id: "deployments",
    path: "/data/physical-ai-deployments",
    preferredPath: "/data/physical-ai-deployments",
    existing: false,
    title: "Physical AI Deployment Tracker",
    seoTitle: "Physical AI Deployment Tracker Robots in Real Work",
    description: "Track documented Physical AI and embodied robotics deployments while separating pilots, agreements, operating sites, model disclosure and intervention evidence.",
    eyebrow: "ANNOUNCED ≠ PILOT ≠ OPERATIONAL",
    methodology: "A partnership announcement is not upgraded into a deployment. When the robot is deployed but the exact Physical AI model is not public, the model field remains Not publicly disclosed instead of guessing which internal policy was used.",
    records: physicalAIDeployments,
    columns: [["model", "Physical AI model"], ["robot", "Robot"], ["robotCompany", "Robot company"], ["customer", "Customer"], ["site", "Deployment site"], ["industry", "Industry"], ["task", "Task"], ["start", "Start"], ["robots", "Robot count"], ["stage", "Stage"], ["operatingHours", "Operating hours"], ["autonomy", "Autonomy evidence"], ["status", "Status"]],
    filters: [["robotCompany", "Robot company"], ["country", "Country"], ["industry", "Industry"], ["stage", "Stage"]],
    updated: "2026-08-13",
  },
  {
    id: "failures",
    path: "/data/physical-ai-failures",
    preferredPath: "/data/physical-ai-failures",
    existing: false,
    title: "Physical AI Failure Database",
    seoTitle: "Physical AI Failure Database Robot Model Evidence",
    description: "Review documented Physical AI task failures and public failure taxonomies without guessing causes or turning isolated events into universal reliability claims.",
    eyebrow: "OBSERVED FAILURE ≠ CONFIRMED CAUSE",
    methodology: "Observed failure, company explanation and independently confirmed cause remain separate fields. When a benchmark publishes only success rate and trial count, the number of unsuccessful trials can be calculated exactly, but the cause stays Unknown unless documented.",
    records: physicalAIFailures,
    columns: [["date", "Date"], ["model", "Model"], ["robot", "Robot"], ["task", "Task"], ["environment", "Environment"], ["failureType", "Failure type"], ["description", "Observed failure"], ["recovered", "Recovery"], ["intervention", "Human intervention"], ["companyExplanation", "Company explanation"], ["confirmedCause", "Confirmed cause"], ["status", "Status"]],
    filters: [["model", "Model"], ["robot", "Robot"], ["failureType", "Failure type"], ["status", "Status"]],
    updated: "2026-08-13",
  },
];

export const physicalAIIntelligenceLinks = physicalAIIntelligencePages.map((page) => ({
  path: page.path,
  label: page.title,
  existing: page.existing,
}));

export function getPhysicalAIIntelligencePageByPath(path) {
  const normalized = (path || "").replace(/\/+$/, "") || "/";
  return physicalAIIntelligencePages.find((page) => page.path === normalized);
}
